import React, { useState } from "react";
import { MessageCircleWarning, CircleCheckBig } from 'lucide-react';
import SbMediaRequestModalPerf from "./SbMediaRequestModalPerf";
import { SbMediaRequestModel } from "../../submission_kits/components/KitModels";

interface MediaRequest {
  id: string;
  message: string;
  daysAgo: number;
  user_name: string;
  status: boolean;
}

interface SbMediaRequestPerfProps {
  requests?: SbMediaRequestModel[];
  fullfillments: any[];
  getSBCreatorName: () => string; 
}

export default function SbMediaRequestPerf({ requests = [], fullfillments,  getSBCreatorName }: SbMediaRequestPerfProps) {
  const [isOpen, setIsOpen] = useState(false);

  console.log('Fullfillments:', fullfillments);

  
  if (requests.length === 0)
    return (
      <>
        <div>No Requests</div>
      </>
    );

  const formattedRequests: MediaRequest[] = requests.map((r) => ({
    id: r.id.toString(),
    message: r.notes,
    status: r.status,
    daysAgo: Math.floor(
      (new Date().getTime() - new Date(r.updated_at).getTime()) / (1000 * 60 * 60 * 24)
    ),
    user_name: r.user?.first_name + ' ' + r.user?.last_name
  }));
  const combinedItems = [
    ...requests.map((r) => ({
      id: r.id.toString(),
      message: r.notes,
      type: 'request' as const,
      status: r.status,
      timestamp: new Date(r.updated_at).getTime(),
      created_at: r.updated_at,
      daysAgo: Math.floor(
        (new Date().getTime() - new Date(r.updated_at).getTime()) / (1000 * 60 * 60 * 24)
      ),
      user_name: r.user?.first_name + ' ' + r.user?.last_name
    })),
    ...fullfillments.map((f) => ({
      id: f.id.toString(),
      type: 'fulfillment' as const,
      timestamp: new Date(f.created_at).getTime(),
      created_at: f.created_at,
      daysAgo: Math.floor(
        (new Date().getTime() - new Date(f.created_at).getTime()) / (1000 * 60 * 60 * 24)
      )
    }))
  ];

    const sortedItems = combinedItems.sort((a, b) => b.timestamp - a.timestamp);
    const filteredItems = sortedItems.filter((item, index) => {
      if (item.type === 'fulfillment' && index > 0) {
        const prevItem = sortedItems[index - 1];
        if (prevItem.type === 'fulfillment') {
          return false; // Consecutive green, skip karo
        }
      }
      return true;
    });

  // const firstRequest = formattedRequests[0];
  // const remainingCount = formattedRequests.length - 1;
  return (
      <div className="gap-5 flex flex-col">
        {filteredItems.map((item) => (
          <div key={`${item.type}-${item.id}`} className="">
            {item.type === 'request' ? (
              <>
                <div className="media-request-box p-7 flex flex-col text-sm rounded-lg">
                  <div className="flex items-center justify-between w-full border-b border-yellow-400 pb-4">
                    <div className="flex items-center gap-2">
                      <MessageCircleWarning className="w-6 h-6" style={{ color: '#FF8400' }} />
                      <h3 className="m-0 text-base font-bold leading-tight text-black">
                        You have received a media upload request.
                      </h3>
                    </div>
                    <div className="text-xs text-gray-600">
                      {item.daysAgo > 0
                        ? `${item.daysAgo} day${item.daysAgo !== 1 ? 's ago' : ' ago'}`
                        : 'today'}
                    </div>
                  </div>
                  <div className="text-sm italic mb-3 pt-4">{item.message}</div>
                  <div className="text-xs font-semibold mb-3 pt-4">{getSBCreatorName()}</div>
                </div>
              </>
            ) : item.type === 'fulfillment' ? (
              <>
                <div className="media-request-box_1 p-7 flex flex-col text-sm rounded-lg">
                  <div className="flex items-center justify-between w-full pb-4">
                    <div className="flex items-center gap-2">
                      <CircleCheckBig className="w-6 h-6 flex-shrink-0" style={{ color: '#2EA901' }} />
                      <h3 className="m-0 mt-2 text-base font-bold leading-tight max-w-xl text-black">
                        We have received your upload and has been submitted for consideration.
                      </h3>
                    </div>
                    <div className="text-xs text-gray-600">
                      {item.daysAgo > 0
                        ? `${item.daysAgo} day${item.daysAgo !== 1 ? 's ago' : ' ago'}`
                        : 'today'}
                    </div>
                  </div>                
                </div>
              </>
            ) : null}
          </div>
        ))}
      </div>
    );
}
